import { render } from "./Example9.vue?vue&type=template&id=4f4a706c"
import script from "./Example9.vue?vue&type=script&lang=ts"
export * from "./Example9.vue?vue&type=script&lang=ts"
script.render = render

export default script